/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';

export const CarouselContainer = styled('div')({
  height: '100%',
  width: '100%',
  position: 'relative',
})

export const NavigationContainer = styled('div')({
  display: 'flex',
  gap: '10px',
  position: 'absolute',
  top: '90vh',
  left: '5vw',
})

export const StyledCircleIcon = styled(CircleIcon)({
  '&;active': {
    opacity: '0',
    color: 'white',
  },
  '&:hover': {
    opacity: '0.2',
  },
  color: 'gray',
  fontSize: '10px',
  opacity: '0.5',
  cursor: 'pointer',
})
